import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {TripbookPackage} from "../../entities/Agency.ts";

export class GetAgencyPackagesUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string): Promise<TripbookPackage[]> {
        return this.agencyRepository.getAgencyPackages(agencyId)
    }
}
